<template>
  <v-card height="100%">
    <project-flow-navigation-toolbar
      :title="projectName"
    ></project-flow-navigation-toolbar>
    <v-card-text style="height: calc(100% - 116px)">
      <v-row>
        <v-col style="min-width: 300px" cols="12" sm="6" md="4">
          <v-treeview
            v-if="items.length"
            selected-color="primary"
            :value="selectedTree"
            @input="setSelected"
            return-object
            selectable
            item-key="uniqueId"
            :selection-type="'independent'"
            :open-all="true"
            activatable
            :active.sync="active"
            hoverable
            :items="items"
          >
            <template v-slot:prepend="{ item, open }">
              <Icon
                :icon="getIcon(item.type)"
                style="font-size: 26px; margin-bottom: -5px"
              />
            </template>
            <template v-slot:label="{ item, open }">
              <span style="cursor: pointer">{{ item.name }}</span>
            </template>
          </v-treeview>
        </v-col>
        <v-col cols="12" sm="6" md="8">
          <v-data-table
            v-if="pois.length > 0"
            v-model="selected"
            @item-selected="changeTree"
            :headers="poiHeaders"
            :items="filteredPois"
            :single-select="false"
            item-key="uniqueId"
            show-select
            class="elevation-0"
          >
            <template v-slot:header.data-table-select>
              <span></span>
            </template>
            <template v-slot:top>
              <v-row
                class="ma-0"
                style="border-bottom: 1px solid rgba(255, 255, 255, 0.12)"
              >
                <v-col class="d-flex align-center">
                  <Icon
                    class="ml-2 mb-1 mr-9"
                    :icon="getIcon(active[0].type)"
                    style="font-size: 26px; margin-bottom: -5px"
                  />
                  <span class="text-h6 font-weight-bold">
                    {{ active[0].name }}
                  </span>
                </v-col>
                <v-col width="200">
                  <v-text-field
                    dense
                    v-model="searchPois"
                    append-icon="mdi-magnify"
                    outlined=""
                    label="Search"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row
                class="ma-0"
                style="border-bottom: 1px solid rgba(255, 255, 255, 0.12)"
              >
                <v-col>
                  <div class="text-body1 font-weight-bold ml-2">INFO POIS</div>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
          <v-data-table
            v-if="apartments.length > 0"
            v-model="selected"
            :headers="apartmentHeaders"
            @item-selected="disabledActions = false"
            :items="filteredApartments"
            :single-select="false"
            item-key="uniqueId"
            show-select
            class="elevation-0"
          >
            <template v-slot:header.data-table-select>
              <span></span>
            </template>
            <template v-slot:item.name="{ item }">
              <tr>
                {{
                  item.data.name
                }}
              </tr>
            </template>
            <template v-slot:item.floor="{ item }">
              <tr>
                {{
                  item.data.floor
                }}
              </tr>
            </template>
            <template v-slot:item.rooms="{ item }">
              <tr>
                {{
                  item.data.rooms
                }}
              </tr>
            </template>
            <template v-slot:item.status="{ item }">
              <tr>
                {{
                  getApartmentStatus(item.data.statusId)
                }}
              </tr>
            </template>
            <template v-slot:top>
              <v-row
                class="ma-0"
                style="border-bottom: 1px solid rgba(255, 255, 255, 0.12)"
              >
                <v-col class="d-flex align-center">
                  <div class="text-body1 font-weight-bold ml-2">APARTMENTS</div>
                </v-col>
                <v-col width="200">
                  <v-text-field
                    dense
                    v-model="searchApartments"
                    append-icon="mdi-magnify"
                    outlined=""
                    label="Search"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pl-5 pr-5 pb-4">
      <v-spacer></v-spacer>
      <v-btn :disabled="disabledActions" small @click="cancel">Cancel</v-btn>
      <v-btn
        :disabled="disabledActions"
        small
        color="primary darken-1"
        @click="save"
        >Save</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import Enums from '@/helpers/Enums'
import { Icon } from '@iconify/vue2'
import ProjectFlowNavigationToolbar from '../components/AppBar/ProjectFlowNavigationToolbar'
export default {
  name: 'MediaManagerEditLinks',
  components: {
    ProjectFlowNavigationToolbar,
    Icon
  },
  created() {
    this.getTreeView()
  },
  mounted() {
    this.$store.dispatch(
      'BreadcrumbsStore/add',
      {
        text: 'MEDIA LINKS ',
        name: ''
      },
      { root: true }
    )
  },
  data() {
    return {
      disabledActions: true,
      pois: [],
      searchPois: null,
      apartments: [],
      searchApartments: null,
      active: [],
      test: [],
      selected: [],
      originalSelected: [],
      selectedTree: [],
      items: [],
      clicked: false,
      checked: false,
      poiHeaders: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name'
        }
      ],
      apartmentHeaders: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Floor',
          align: 'start',
          sortable: false,
          value: 'floor'
        },
        {
          text: 'Rooms',
          align: 'start',
          sortable: false,
          value: 'rooms'
        },
        {
          text: 'Status',
          align: 'start',
          sortable: false,
          value: 'status'
        }
      ]
    }
  },
  methods: {
    setSelected(e) {
      this.disabledActions = false
      let selected = JSON.parse(JSON.stringify(this.selected))
      let selectedTree = JSON.parse(JSON.stringify(this.selectedTree))
      if (e.length > selectedTree.length) {
        var newEl = e.filter(function(obj) {
          return !selectedTree.some(function(obj2) {
            return obj.uniqueId === obj2.uniqueId
          })
        })
        this.selected = this.selected.concat(newEl)
      } else {
        var toRemove = selectedTree.filter(function(obj) {
          return !e.some(function(obj2) {
            return obj.uniqueId === obj2.uniqueId
          })
        })
        if (toRemove.length > 0) {
          for (var i = 0; i < selected.length; i++) {
            if (toRemove[0].uniqueId === selected[i].uniqueId) {
              selected.splice(i, 1)
            }
          }
        }
        this.selected = selected
      }
      this.selectedTree = e
    },
    changeTree(e) {
      this.disabledActions = false
      setTimeout(() => {
        let record = this.findRecord(e.item.uniqueId, this.items)
        if (record && e.value) {
          let tempSelectedTree = JSON.parse(JSON.stringify(this.selectedTree))
          tempSelectedTree.push(e.item)
          this.selectedTree = tempSelectedTree
        } else if (record && !e.value) {
          let tempSelectedTree = JSON.parse(JSON.stringify(this.selectedTree))
          for (var i = 0; i < tempSelectedTree.length; i++) {
            if (tempSelectedTree[i].uniqueId === record.uniqueId) {
              tempSelectedTree.splice(i, 1)
            }
          }
          this.selectedTree = tempSelectedTree
        }
      }, 10)
    },
    save() {
      this.clicked = true
      let checked = this.selected.map(temp => {
        let tempCopy = JSON.parse(JSON.stringify(temp))
        if (tempCopy.children) {
          delete tempCopy.children
        }
        if (tempCopy.pois) {
          delete tempCopy.pois
        }
        if (tempCopy.apartments) {
          delete tempCopy.apartments
        }
        return tempCopy
      })
      console.log('save', checked)
      let params = {
        mediaId:
          this.$store.state.MediaManagerStore.checkedMedia.length > 0
            ? this.$store.state.MediaManagerStore.checkedMedia
            : this.$store.state.MediaManagerStore.selectedMediaItem.id,
        selected: checked
      }
      this.$store
        .dispatch('MediaManagerStore/setMediaLinks', params)
        .then(res => {
          console.log(res)
          this.updateSelected()
          this.$store.dispatch('MediaManagerStore/resetCheckedMedia')
          this.$router.go(-1)
        })
    },
    cancel() {
      this.updateSelected()
    },
    async fetchPois(uniqueId) {
      let record = await this.findRecord(uniqueId, this.items)
      this.pois = record.pois
    },
    findRecord(uniqueId, array) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].uniqueId === uniqueId) {
          return array[i]
        } else if (array[i].children && array[i].children.length > 0) {
          let el = this.findRecord(uniqueId, array[i].children)
          if (el && el.uniqueId === uniqueId) {
            return el
          }
        }
      }
    },
    updateSelected() {
      this.$store
        .dispatch(
          'MediaManagerStore/getTreeView',
          this.$store.state.MediaManagerStore.selectedMediaItem.id
        )
        .then(r => {
          let selected = r.data.selected
          let tempSelected = []
          let tempSelectedTree = []
          for (var i = 0; i < selected.length; i++) {
            let record = this.findRecord(selected[i].uniqueId, this.items)
            if (record) {
              tempSelectedTree.push(record)
            }
            tempSelected.push(selected[i])
          }
          this.selected = tempSelected
          this.selectedTree = tempSelectedTree
          this.disabledActions = true
        })
    },
    getTreeView() {
      this.$store
        .dispatch(
          'MediaManagerStore/getTreeView',
          this.$store.state.MediaManagerStore.selectedMediaItem.id
        )
        .then(r => {
          let ar = []
          ar.push(r.data.data)
          this.items = ar
          let selected = r.data.selected
          let tempSelected = []
          let tempSelectedTree = []
          for (var i = 0; i < selected.length; i++) {
            let record = this.findRecord(selected[i].uniqueId, this.items)
            if (record) {
              tempSelectedTree.push(record)
            }
            tempSelected.push(selected[i])
          }
          this.selected = tempSelected
          this.selectedTree = tempSelectedTree
        })
    }
  },
  computed: {
    projectName: function() {
      return this.$store.state.ProjectStore.selectedProject
        ? this.$store.state.ProjectStore.selectedProject.name
        : ''
    },
    getIcon() {
      return type => {
        let str = 'emojione-monotone:letter-'
        let letter = type.substr(0, 1).toLowerCase()
        return str + letter
      }
    },
    filteredPois() {
      if (!this.searchPois) {
        return this.pois
      }
      return this.pois.filter(poi => {
        return (
          poi.name.toLowerCase().indexOf(this.searchPois.toLowerCase()) != -1
        )
      })
    },
    filteredApartments() {
      if (!this.searchApartments) {
        return this.apartments
      }
      return this.apartments.filter(apartment => {
        return (
          apartment.name
            .toLowerCase()
            .indexOf(this.searchApartments.toLowerCase()) !== -1
        )
      })
    },
    getApartmentStatus() {
      return id => {
        for (const property in Enums.ApartmentStatus) {
          if (Enums.ApartmentStatus[property] === id) {
            return this.$t(`apartmentStatuses.${property}`)
          }
        }
        return id
      }
    }
  },
  watch: {
    active: function() {
      if (this.active[0]) {
        if (this.active[0].pois && this.active[0].pois.length > 0) {
          this.pois = this.active[0].pois
        } else {
          this.pois = []
        }
        if (this.active[0].apartments && this.active[0].apartments.length > 0) {
          this.apartments = this.active[0].apartments
        } else {
          this.apartments = []
        }
      } else {
        this.pois = []
        this.apartments = []
      }
    },
    selected: {
      deep: true,
      handler: function(after, before) {
        if (this.originalSelected.length == 0 && !this.checked) {
          this.originalSelected = this.selected
          this.checked = true
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      !this.clicked &&
      this.originalSelected.sort().join('') !== this.selected.sort().join('')
    ) {
      this.$store.dispatch('DialogStore/open', {
        title: 'You did not save the data!',
        text: 'All changes will be lost!',
        okText: 'Stay',
        ok: () => {
          next(false)
        },
        cancelText: 'Discard and leave',
        cancel: () => {
          next()
        }
      })
    } else {
      next()
    }
  }
}
</script>

<style lang="css"></style>
